// material-ui
import { Theme, alpha } from '@mui/material/styles';
// types
import { CustomGradientProps } from 'types/theme';
import { ThemeMode } from 'config';
import { PresetColor } from 'types/config';

type PrimaryScale = {
  darker?: string;
  dark?: string;
  main?: string;
  light?: string;
  lighter?: string;
  900?: string;
  100?: string;
  50?: string;
  [key: string]: string | undefined;
};

// Direção: superior esquerdo (tom mais escuro) → inferior direito (tom mais claro)
const GRADIENT_DIR = 'to bottom right';

// theme1 (dark): fundo da página — roxo quase preto, opaco (sem desvanecer para clarear)
const THEME1_APP_DARK = 'linear-gradient(160deg, #0A0413 0%, #0D0619 55%, #08030F 100%)';
// theme1 (dark): superfícies (cards/paper) — roxo um pouco mais claro p/ destacar do fundo
const THEME1_PAPER_DARK = 'linear-gradient(160deg, #130A22 0%, #180D2B 100%)';
// theme1 (dark): toolbar/appbar — tom intermediário
const THEME1_TOOLBAR_DARK = 'linear-gradient(160deg, #0F0720 0%, #140A26 100%)';

// theme1 (light): gradiente lavanda claro (160deg, branco-violáceo → transparente)
const THEME1_GRADIENT_LIGHT =
  'linear-gradient(160deg, rgba(248, 245, 253, 0.96) 0%, rgba(241, 234, 251, 0.92) 45%, rgba(255, 255, 255, 0.6) 100%)';

// ==============================|| CUSTOM GRADIENTS (MODELO PARA TODOS OS TEMAS) ||============================== //
/**
 * theme1: gradiente violeta — escuro no modo dark, lavanda claro no modo light.
 * Demais temas: superior esquerdo = tom mais escuro do primary → inferior direito = tom mais claro.
 */
export default function CustomGradients(theme: Theme, presetColor?: PresetColor): CustomGradientProps {
  const isDark = theme.palette.mode === ThemeMode.DARK;

  if (presetColor === 'theme1') {
    if (isDark) {
      return {
        appBg: THEME1_APP_DARK,
        paperBg: THEME1_PAPER_DARK,
        toolbarBg: THEME1_TOOLBAR_DARK
      };
    }
    return {
      appBg: THEME1_GRADIENT_LIGHT,
      paperBg: THEME1_GRADIENT_LIGHT,
      toolbarBg: THEME1_GRADIENT_LIGHT
    };
  }

  const p = (theme.palette.primary || {}) as unknown as PrimaryScale;

  const tomMaisEscuro = p.darker || p[900] || p.dark || p.main || '#0a0a0a';
  const tomMaisClaro = p.lighter || p[50] || p[100] || p.light || p.main || '#888';
  const op = (a: number, b: number) => (isDark ? a : b);
  const mid = p.main || p.dark || tomMaisEscuro;

  const appBg = `
    linear-gradient(
      ${GRADIENT_DIR},
      ${alpha(tomMaisEscuro, op(0.98, 0.95))} 0%,
      ${alpha(p.dark || mid, op(0.85, 0.6))} 40%,
      ${alpha(mid, op(0.65, 0.4))} 70%,
      ${alpha(tomMaisClaro, op(0.4, 0.22))} 100%
    )`;

  const paperBg = `
    linear-gradient(
      ${GRADIENT_DIR},
      ${alpha(tomMaisEscuro, op(0.78, 0.45))} 0%,
      ${alpha(mid, op(0.58, 0.3))} 50%,
      ${alpha(tomMaisClaro, op(0.38, 0.18))} 100%
    )`;

  const toolbarBg = `
    linear-gradient(
      ${GRADIENT_DIR},
      ${alpha(tomMaisEscuro, op(0.94, 0.85))} 0%,
      ${alpha(mid, op(0.72, 0.5))} 50%,
      ${alpha(tomMaisClaro, op(0.45, 0.25))} 100%
    )`;

  return {
    appBg,
    paperBg,
    toolbarBg
  };
}
